import moment from 'moment';

class AddSubcontractorEmployeeModalController {
  constructor($scope, $uibModalInstance, $rootScope, $http) {
    "ngInject";
    this.name = 'AddSubcontractorEmployeeModal';

    $scope.subEmployee = {
      'firstName': '',
      'lastName' : '',
      'userName': '',
      'userType': 'hourly',
      'trackLeave' : false,
      'manager' : 0,
      'typeOfUser' : "subcontractor",
      'title' : ""
    };


    $http.get($rootScope.apiHost + '/api/admin/users/names?active=true', {withCredentials: true})
      .then(success => {
        $scope.allUsers = success.data;
      });

    $http.get($rootScope.apiHost+'/api/admin/contracts?activeOnly=true&allowSubcontracting=true', {withCredentials: true}).then(function (success) {
      $scope.contractOptions = success.data;
    });

    let self = this;
    $scope.addSubcontractEmployee = function () {
      $uibModalInstance.success($scope.subEmployee);
    }


    $scope.addManager = function(user) {
      $scope.subEmployee.manager = user.id;
    }

    $scope.onManagerBlur = function(event) {
      if (event.currentTarget.value === '' || event.currentTarget.value === undefined) {
        $scope.subEmployee.manager = 0;
      }
    }
  }
}

export default AddSubcontractorEmployeeModalController;



// WEBPACK FOOTER //
// ./client/common/modals/addSubcontractorEmployee/addSubcontractorEmployeeModal.controller.js